module.exports = __webpack_public_path__ + "img/Assets-01.bd66b7ae.png";